// Module
var code = "<gh-dialog> <gh-dialog-header title=\"{{'Map' | translate}}\"></gh-dialog-header> <gh-dialog-content> <gh-mapbox-map [coordinates]=\"coordinates\" [zoom]=\"17\" [isUserDrag]=\"isUserDrag\" (coordinatesChanged)=\"onCoordinatesChanged($event)\"> </gh-mapbox-map> </gh-dialog-content> </gh-dialog> ";
// Exports
module.exports = code;